<template>
  <component :is="currentComponent" :key="`${purchaseType}-${$route.path}`">
  </component>
</template>
<script>
import { mapGetters } from "vuex";
const NewTransfers = () =>
  import("@/modules/reservations/pages/transfers/NewTransfers.vue");
const NewExperiences = () =>
  import("@/modules/reservations/pages/experiences/NewExperiences.vue");

export default {
  computed: {
    ...mapGetters(["purchaseType"]),
    currentComponent() {
      return this.purchaseType === "TRANSFER_RESERVATION"
        ? NewTransfers
        : NewExperiences;
    }
  }
};
</script>
